export const AUTH_METHODS = Object.freeze({
    wamToken: 'wamToken',
    oauth2: 'oauth2',
  } as const);

  // Normally the refresh token is used every 5 minutes to get a new access token
  // This buffer is used to refresh the token earlier than the 5 minutes to avoid any issues
  // This buffer can be altered if you want to refresh the token earlier
  // This can be useful for manual testing for example set it to 270,000 (4.5 minutes) to test the refresh token functionality more often
  export const REFRESH_TOKEN_BUFFER = 30000; 

  export const STORAGE_PREFIX = `_auth_`;